export const GOOGLE_PLAY_STORE_APP_URL = "https://play.google.com/store/apps/details?id=com.capitalrx.advantage";
export const APPLE_STORE_APP_URL = "https://apps.apple.com/us/app/crx-advantage-savings/id1516648365";
export const MIN_SEARCH_LENGTH = 3;
